import * as Sentry from "@sentry/browser"

function readMeta(name) {
  const element = document.querySelector(`meta[name="${name}"]`)
  return element ? element.getAttribute("content") : null
}

function parseSampleRate(value, fallback) {
  const parsed = parseFloat(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

export function initSentry() {
  if (window.__sentryInitialized) { return }

  const dsn = readMeta("sentry-dsn")
  if (!dsn) { return }

  Sentry.init({
    dsn,
    environment: readMeta("sentry-environment") || "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true
      })
    ],
    ignoreErrors: [
      /^TurnstileError/,
      /\[Cloudflare Turnstile\] Error:/
    ],
    tracesSampleRate: parseSampleRate(readMeta("sentry-traces-sample-rate"), 0.1),
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/donate\.daps\.(us|org)/
    ],
    replaysSessionSampleRate: parseSampleRate(readMeta("sentry-replays-session-sample-rate"), 0.1),
    replaysOnErrorSampleRate: parseSampleRate(readMeta("sentry-replays-on-error-sample-rate"), 1.0)
  })

  window.__sentryInitialized = true
}
